/** How a conversation row reads — shared by the Communications page and a record's own list. */

const CHIP_TONES = [
  'bg-blue-50 text-blue-700',
  'bg-emerald-50 text-emerald-700',
  'bg-purple-50 text-purple-700',
  'bg-amber-50 text-amber-700',
  'bg-rose-50 text-rose-700',
  'bg-cyan-50 text-cyan-700',
];

/**
 * A participant's chip colour, derived from their id.
 *
 * Deterministic rather than assigned per row, so one person is the same colour
 * on every line of the table — which is the only thing that makes a wall of
 * chips scannable.
 */
export function chipTone(recipientId: string): string {
  let hash = 0;
  for (const char of recipientId) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return CHIP_TONES[hash % CHIP_TONES.length]!;
}

/** "38m ago", "3d ago", then a date once "days ago" stops meaning anything. */
export function relativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '—';
  const seconds = Math.max(0, Math.round((Date.now() - then) / 1000));
  if (seconds < 60) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(iso).toLocaleDateString();
}
